<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.885 11.2661L26.0277 11.318C29.9999 12.7656 29.9999 12.9342 30 13.3424V16.522C30 16.9298 30 17.083 26.0298 18.6548L25.8968 18.7081L25.3395 20.0587L25.4057 20.2023C27.185 24.0243 27.0675 24.1441 26.7837 24.4333L26.7833 24.4337L24.5254 26.6877C24.4314 26.7828 24.2677 26.8445 24.1299 26.8445C23.7894 26.8445 22.4755 26.3541 20.2259 25.3825L20.0958 25.3283L18.7284 25.8926L18.6743 26.0369C17.2227 30 17.057 30 16.6576 30H13.476C13.0866 30 12.9258 30 11.3606 26.0477L11.3072 25.9075L9.93399 25.3406L9.8007 25.4043C6.47225 26.9414 6.08934 26.9414 5.96343 26.9414C5.8243 26.9414 5.66115 26.8753 5.56688 26.7828L3.31814 24.537L3.3177 24.5365C3.0306 24.2451 2.9245 24.1373 4.61203 20.2287L4.67198 20.0905L4.11367 18.738L3.9717 18.6868C0 17.2338 0 17.0642 0 16.6559V13.4744C0 13.0672 0 12.9147 3.96383 11.3511L4.10045 11.2972L4.65867 9.94062L4.59337 9.79869C2.81654 5.97146 2.93515 5.85089 3.22112 5.56295L5.47537 3.31379C5.56786 3.22079 5.73011 3.15711 5.86916 3.15711C6.21184 3.15711 7.52641 3.64843 9.77782 4.61733L9.90835 4.67273L11.2735 4.10464L11.3281 3.96047C12.7786 0 12.9552 0 13.343 0H16.5236C16.9128 0 17.073 0 18.6372 3.95359L18.6923 4.09305L20.0646 4.65716L20.198 4.59605C23.5243 3.05823 23.9081 3.05823 24.0348 3.05823C24.1742 3.05823 24.3358 3.12382 24.4279 3.21707L26.6801 5.45977L26.6802 5.45995C26.9602 5.7432 27.0762 5.86059 25.3881 9.76854L25.3277 9.90808L25.885 11.2661ZM9.84499 15.0006C9.84499 17.8444 12.1574 20.1598 14.9999 20.1598C17.8413 20.1598 20.1533 17.8439 20.1532 15.0006C20.1532 12.1572 17.8412 9.84442 14.9999 9.84442C12.1575 9.84442 9.84499 12.1567 9.84499 15.0006Z"/>
  </svg>
</template>
